// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"uZ-z","vrsnlCrossSiteLabel":"vZ-z"};